module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_8011.14552c2d.png";